import { TranslationKey } from '../translation/TranslationKey';
import { t } from '../translation/Translator';
import { StockLocationRole } from './stockLocationRoleAssignment';

export namespace StockLocationRoleAssignmentUtil {
  export function roleToString(type: string) {
    switch (type) {
      case StockLocationRole.STOCK_LOCATION_MANAGER:
        return t(TranslationKey.manager).singular.label;
      case StockLocationRole.STOCK_LOCATION_SUPERVISOR:
        return t(TranslationKey.supervisor).singular.label;
      case StockLocationRole.STOCK_LOCATION_USER:
        return t(TranslationKey.fieldUser).singular.label;
      case StockLocationRole.STOCK_LOCATION_VIEWER:
        return t(TranslationKey.viewer).singular.label;
      default:
        return 'Unknown stock location user role';
    }
  }
}
